module.exports = __webpack_public_path__ + "static/media/language-evaluation-icon.0990d987.svg";